import React from 'react';
import ContactAddress from './ContactAddress';
import ContactInput from './ContactInput';
import ContactMap from './ContactMap';

const Contact = () => {
    return (
        <div className='bg-white w-full mx-auto py-10 px-5'>
            <ContactInput />
            <ContactAddress/>
            <ContactMap/>
        </div>
    );
};

export default Contact;